// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"148":"3f96076ea78798626bca","351":"8dcc8e567d7789e4be44"}[chunkId] + "";
};